/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import CustomDataGrid from "../Shared/Table/CustomDataGrid";
import { useDeviceConfigTemplateDisplay } from "./Templates/hooks";
import { GridRowParams, GridToolbarContainer } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import { prepareLocalTemplateCellDataGrid } from "../../pages/Configuration/helpers";
import { IFullDeviceDetails } from "../../store/api/deviceConfig/types";
import { useSelector } from "react-redux";
import { selectedDeviceSelector } from "../../store/api/devices/selectors";
import TemplateAttributesDrawer from "../Drawers/TemplateAttributesDrawer";

interface IProps {
  templateType: string;
}

const LocalTemplates: React.FC<IProps> = ({ templateType }) => {
  const { data = [], isLoading, panelTemplatesColumns } = useDeviceConfigTemplateDisplay();
  const selectedDevice: IFullDeviceDetails = useSelector(selectedDeviceSelector);
  const rowsData = prepareLocalTemplateCellDataGrid(data, selectedDevice?.objectKey || "") || [];
  const [selectedTemplateRow, setSelectedTemplateRow] = React.useState<any | null>(null);
  const [isAttributesDrawerOpen, setIsAttributesDrawerOpen] = React.useState(false);

  const handleTemplateRowClick = (params: GridRowParams<any>, event: any) => {
    if ((event?.target as HTMLElement)?.closest("button")) {
      return;
    }
    setSelectedTemplateRow(params?.row || null);
    setIsAttributesDrawerOpen(true);
  };

  const DataGridTitle = () => {
    return (
      <GridToolbarContainer sx={{ justifyContent: "space-between" }}>
        <Typography variant="body2" >{`Showing ${rowsData?.length || 0} results`}</Typography>
      </GridToolbarContainer>
    )
  }
  return (
    <div className="w-full">
      {!!selectedTemplateRow && (
        <TemplateAttributesDrawer
          open={isAttributesDrawerOpen}
          onClose={() => setIsAttributesDrawerOpen(false)}
          templateId={selectedTemplateRow.templateName || ""}
          templateDisplayName={selectedTemplateRow.templateName || "Template"}
        />
      )}
      <CustomDataGrid
        tableId="localTemplate"
        sx={{ height: "420px" }}
        rows={rowsData}
        columns={panelTemplatesColumns}
        rowCount={rowsData?.length}
        loading={isLoading}
        disableColumnMenu={true}
        //getRowId={(row: ITemplates) => row.id}
        onRowClick={handleTemplateRowClick}
        slots={{ toolbar: DataGridTitle }}
        hideFooter={true}
        sortingMode="client"
        pagination={false}
      />
    </div>
  );
};

export default LocalTemplates;
